import React, { useCallback } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import Panel from "./right-panel";
import { LeftVideo } from "./left-video";
import { LeftImage } from "./left-image";
import { LeftMoments } from "./left-moments";
import { LeftArticle } from "./left-article";
import { LeftPodcast } from "./left-podcast";
import { AgentV2PushContentDetailData } from "@/services/agent-v2-push-content-detail";
import { cn } from "@/lib/utils";
import { LeftAiCreation } from "./left-ai-creation";

interface ContentDetailModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  loading?: boolean;
  details?: AgentV2PushContentDetailData;
}

/** 内容详情弹窗 */
export const ContentDetailModal: React.FC<ContentDetailModalProps> = ({
  open,
  loading = false,
  details,
  onOpenChange,
}) => {
  const handleOpenChange = (open: boolean) => {
    onOpenChange(open);
  }

  const renderLeft = useCallback(() => {
    if (!details) return null;
    // 失败不展示
    if ([2, 10].includes(details?.status)) return null;

    switch (details.contentType) {
      case 1:
        return <LeftVideo details={details} />;
      case 2:
        return <LeftPodcast details={details} />;
      case 3:
        return <LeftMoments details={details} />;
      case 4:
        return <LeftImage details={details} />;
      case 5:
        return <LeftArticle details={details} />;
      case 6:
        return <LeftAiCreation details={details} />;
      default:
        return null;
    }
  }, [details]);

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50" />
        <Dialog.Content className={cn(
          "fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[750px] max-w-[1000px] max-h-[750px] rounded-2xl shadow-lg z-50 flex overflow-hidden",
          [2, 10].includes(details?.status) && 'max-w-[578px]',
        )}>
          {/* 左侧区域 */}
          {details && Object.keys(details).length > 0 ? renderLeft() : (
            <div className="flex-1 h-full relative bg-gray-200 flex flex-col border-r border-r-[rgba(233,234,235,1)] "></div>
          )}
          {/* 右侧信息面板 */}
          <Panel
            details={details}
            loading={loading}
            onClose={() => {
              onOpenChange(false);
            }}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};